export default function updateBounds(map) {
  const markers = map.$children;
  const bounds = new google.maps.LatLngBounds();
  markers.forEach((marker) => {
    bounds.extend(marker.position);
  });
  map.fitBounds(bounds);
}
